import {Deal} from "@irati/types"
import hasPerksGOLocations from "@irati/deals/helpers/deals/hasPerksGOLocations"
import isPerksGORetailDeal from "@irati/deals/helpers/deals/isPerksGORetailDeal"

const isPerksGO = (deal: Deal) => {
  return (isPerksGORetailDeal(deal) || hasPerksGOLocations(deal))
}

export default isPerksGO
